module.exports = __webpack_public_path__ + "img/khjk1.c66adb5b.png";